'use client';

import { useEffect, useState } from 'react';
import { ICompanyResponse } from '@sapientpro/sapientpro-data-models';
import styles from './Company.module.scss';
// eslint-disable-next-line import/no-absolute-path
import PlayButton from '/public/media/play.svg'; // need to import like that because svg gradient not working in other cases

const CompanyVideo = ({ videoId }: { videoId: ICompanyResponse['videoId'] }) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  useEffect(() => {
    document.documentElement.style.overflowY = isVideoModalOpen ? 'hidden' : 'unset';
  }, [isVideoModalOpen]);

  return (
    <>
      <div className={styles.videoWrap}>
        <button
          type='button'
          className={styles.video__controlButton}
          onClick={() => setIsVideoModalOpen(true)}
        >
          <PlayButton />
        </button>
        <div className={styles.video}>
          <iframe
            loading='lazy'
            src={`https://www.youtube.com/embed/${videoId}?rel=0&enablejsapi=1&autoplay=1&loop=1&controls=0&mute=1&playlist=${videoId}`}
            title='About Sapient Pro'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          />
        </div>
      </div>
      {isVideoModalOpen && (
      <div className={styles.videoModal}>
        <button
          type='button'
          className={styles.closeButton}
          onClick={() => setIsVideoModalOpen(false)}
        >
          <svg>
            <use
              xlinkHref='/media/menuClose.svg#menuCloseSVG'
              href='/media/menuClose.svg#menuCloseSVG'
            />
          </svg>
        </button>
        <div className={styles.videoModal__playerWrap}>
          <div className={styles.videoModal__player}>
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?rel=0&enablejsapi=1&autoplay=1`}
              title='About Sapient Pro'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              allowFullScreen
            />
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default CompanyVideo;
